import Modal from '@sdk/components/ui/modal/Modal';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { SaveClientFlags } from '@sdk/authentication/types';

import ExclamationYellowIcon from '@web/assets/svg/Icons/48/announcement-yellow.svg';
import BodyPortal from '@web/components/BodyPortal';
import {
  BillingWarningCTA,
  BillingWarningContainer,
  BillingWarningDescription,
  BillingWarningTitle,
} from '@web/account/billingWarnings/billingWarnings.styles';

import { useMissingBillingAddressModal } from './missingBillingAddress.hooks';

export type Props = {
  saveClientFlags: SaveClientFlags;
  currentUser: AuthUserType;
};

export const MissingBillingAddressModal = (props: Props) => {
  const { isVisible, isDismissable, navigateToBilling, onClose } =
    useMissingBillingAddressModal(props);

  return isVisible ? (
    <BodyPortal>
      <Modal
        isVisible={isVisible}
        onDismiss={onClose}
        config={{
          noDismiss: !isDismissable,
          hideClose: !isDismissable,
        }}>
        <BillingWarningContainer alignItems="center">
          <ExclamationYellowIcon />
          <BillingWarningTitle themeColor={ThemeColorType.warning}>
            {gettext('Update your billing information')}
          </BillingWarningTitle>

          <BillingWarningDescription>
            {gettext('Your billing information is incomplete.')}
            <br />
            {gettext(`Please add your billing address at your earliest convenience.`)}
          </BillingWarningDescription>

          <BillingWarningCTA buttonType={ButtonType.primary} onClick={navigateToBilling}>
            {gettext('Update now')}
          </BillingWarningCTA>
        </BillingWarningContainer>
      </Modal>
    </BodyPortal>
  ) : null;
};
